module.exports = __webpack_public_path__ + "547320984554ba58870100a0e30b47d5.svg";